import { useOrgConfigStateValue } from 'hooks/business/useOrgConfig';

export const useIsYPHH = () => {
  const { whiteListConfig } = useOrgConfigStateValue();

  const enable = whiteListConfig?.YPHH ?? false;

  return enable;
};
